import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, TextField, Button, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { JOB_POSITIONS, routes } from '@carcareers/utils';

export const JobseekerHomeSearch: FC = () => {
  const navigate = useNavigate();
  const [positions, setPositions] = useState<any[]>([]);

  return (
    <>
      <Autocomplete
        freeSolo
        options={JOB_POSITIONS}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          return option.position;
        }}
        groupBy={(option) => {
          if (typeof option === 'string') {
            return '';
          }
          return option.department;
        }}
        onChange={(_, value) => {
          if (value != null) {
            setPositions(Array.isArray(value) ? value : [value]);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Job title, keywords, or company"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <SearchIcon
                    sx={{ color: 'action.active', mr: 1, fontSize: '2rem' }}
                  />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
            sx={{
              '& .MuiInputBase-root': {
                p: 2,
                fontSize: '1.2rem',
              },
            }}
          />
        )}
        sx={{
          width: '100%',
          display: 'flex',
        }}
      />

      <Button
        variant="contained"
        color="secondary"
        onClick={() =>
          navigate(`/${routes.JOBSEEKERS}`, { state: { searchPositions: positions } })
        }
        sx={{
          width: { xs: '100%', sm: '250px' },
          minHeight: '56px',
        }}
      >
        <Typography component="p" variant="h5" color="primary.contrastText">
          Search Jobs
        </Typography>
      </Button>
    </>
  );
};

export default JobseekerHomeSearch;
